// See confluence /wiki/spaces/ECOMM/pages/2344157235/Payment+Integration+Service for API implementation ticket

// /PaymentIntegrationService/PaymentIntegrationService.svc/SavePayment - Save one payment for a user
// /PaymentIntegrationService/PaymentIntegrationService.svc/DeletePayment - Delete one payment for a user
// /PaymentIntegrationService/PaymentIntegrationService.svc/GetAllPayments - Get all payments for a user

import {AxiosPromise, AxiosRequestConfig} from 'axios';
import api, {PROXY_BASE_URL} from 'services/api/api';

const PAYMENTINTEGRATION_LB = 'lb://paymentintegration';
export const PAYMENTINTEGRATION_BASE_URL = `${PROXY_BASE_URL}?${PAYMENTINTEGRATION_LB}`;

const PaymentIntegrationAPI = (config: AxiosRequestConfig): AxiosPromise => {
  config.baseURL = `${api.defaults.baseURL}${PAYMENTINTEGRATION_BASE_URL}`;
  return api.request(config);
};

// Note: I list these duplicates with the spaces first so that is what is returned for the CardIssuerNameLookup.
export const CardIssuerCodeLookup = {
  None: 'NA',
  VISA: 'VS',
  MASTERCARD: 'MC',
  'AMERICAN EXPRESS': 'AX',
  AMEX: 'AX',
  DISCOVER: 'NS',
  'DINERS CLUB': 'DC',
  DINERSCLUB: 'DC',
  'JAPAN CREDIT BUREAU': 'JC',
  JCB: 'JC',
  'UNION PAY': 'UP',
  CHINAUNIONPAY: 'UP',
};

export const CardIssuerNameLookup = code => {
  for (const [name, cardCode] of Object.entries(CardIssuerCodeLookup)) {
    if (cardCode === code) {
      return name;
    }
  }
  // Handle the case where code doesn't match any provider
  return 'N/A';
};

export interface PaymentIntegrationSaveOptions {
  paymentKey: string;
  sessionKey: string;
  cardHolder: string;
  cardNickname?: string;
  cardIssuerFullName: string;
  // not sent to the API:
  cardMask: string;
  cardExpiration: string;
  cardIssuer: string;
  recaptchaToken: string;
}

export interface PaymentIntegrationSaveAPIParams
  extends PaymentIntegrationSaveOptions {
  token: string;
  propCode: string;
}

export interface PaymentIntegrationDeleteOptions {
  cardMask: string;
  cardExpiration: string;
}

export interface PaymentIntegrationDeleteAPIParams
  extends PaymentIntegrationDeleteOptions {
  token: string;
}

export const savePayment = async (data: PaymentIntegrationSaveAPIParams) => {
  return PaymentIntegrationAPI({
    url: '/SavePayment',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      // Note: we are doing it this way because the object contains values that aren't sent to the API
      token: data.token,
      propCode: data.propCode,
      paymentKey: data.paymentKey,
      sessionKey: data.sessionKey,
      cardHolder: data.cardHolder,
      cardNickname: data.cardNickname,
      cardIssuerFullName: data.cardIssuerFullName,
      recaptchaToken: data.recaptchaToken,
    },
  });
};

export const deletePayment = async (
  data: PaymentIntegrationDeleteAPIParams
) => {
  return PaymentIntegrationAPI({
    url: '/DeletePayment',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  });
};

export const getAllPayments = async (token: string) => {
  return PaymentIntegrationAPI({
    url: '/GetAllPayments',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      token,
    },
  });
};
